export default {
      id: "add-event-usage",
      viewBox: "0 0 65 65",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#add-event",
      toString: function () {
        return this.url;
      }
    }